export const crmMarketRegionQueryRootKey = ["crm_market_region"] as const;

export const crmMarketRegionDefaultListParams = {
  page: 1,
  pageSize: 20,
};

export const marketRegionTypeLabels = {
  province_area: "省份区域",
  city_area: "城市区域",
  school_area: "学校区域",
  custom_area: "自定义区域",
} as const;

export const marketRegionScopeTypeLabels = {
  province: "省份",
  city: "城市",
  organization: "学校/单位",
  organization_unit: "院系/专业",
  customer: "客户",
  contact: "联系人",
} as const;

export const marketRegionMemberRoleLabels = {
  owner: "负责人",
  manager: "协管人",
  viewer: "观察人",
} as const;
